import api from "./Api";

class GeneratorService {
  GetGenerator(payload) {
    return api.get("/v1/generator/" + payload).then((response) => {
      return response.data;
    });
  }

  PostGenerator(payload) {
    return api.post("/v1/generator/", payload).then((response) => {
      return response.data;
    });
  }

  PutGenerator(payload) {
    return api.put("/v1/generator/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteGenerator(payload) {
    return api.delete("/v1/generator/" + payload).then((response) => {
      return response.data;
    });
  }

  GetGeneratorOData(payload) {
    return api.get("/OData/Generator" + payload).then((response) => {
      return response.data;
    });
  }

  UpdateGeneratorTabela(payload) {
    return api
      .post("/v1/Generator/UpdateGeneratorTabela" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new GeneratorService();
